export const IDENTICAL = {
  USERNAME: "chris@gempages.help",
  PASSWORD: "b94add01351e",
  KEY: "gempages2019"
};
